<template>
<div class="page-box" >
 
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 25px; margin-top: 25px; margin-left: 15px;">
        <el-breadcrumb-item>订单</el-breadcrumb-item>
        <el-breadcrumb-item>店铺订单</el-breadcrumb-item>
    </el-breadcrumb>

    <order-step style="margin: 0px 15px 15px 15px;"></order-step>
    <order-query ref="orderQueryRef"  @search="doSearch" @syncExpress="doTrackExpress" @syncShop="syncShop" @batchBuy="batchBuy" @export-detail="exportDetail" @match-stock="matchStock" style="margin: 0px 15px 15px 15px;"></order-query>
    
    <div class="order-table-wrap">
        <div class="table-header" style="margin: 0px 15px 15px 15px;font-size:13px;">
            <div class="query-row" style="display: flex; gap: 15px; flex-wrap: wrap; justify-content: space-between; padding: 10px 15px 0px 15px;">
                <div style="display: flex; gap: 15px; flex-wrap: wrap;">
                    <el-button type="primary" size="mini" icon="el-icon-search" @click="searchFromHeader" color="#2b92f6" radius="2px">
                        搜索
                    </el-button>
                    <el-button type="primary" size="mini" icon="el-icon-shopping-cart-2" @click="batchBuy" color="#2b92f6" radius="2px">
                        批量采购
                    </el-button>
                    <el-button type="primary" size="mini" icon="el-icon-paperclip" @click="doTrackExpress" color="#2b92f6" radius="2px" :disabled="isSyncExpressDisabled">
                        同步快递
                    </el-button>
                    <el-button type="primary" size="mini" icon="el-icon-paperclip" @click="syncShop" color="#2b92f6" radius="2px">
                        同步订单
                    </el-button>
                    <el-button type="primary" size="mini" icon="el-icon-download" @click="exportDetail" color="#2b92f6" radius="2px">
                        导出订单
                    </el-button>
                    <el-button type="primary" size="mini" icon="el-icon-paperclip" @click="matchStock" color="#2b92f6" radius="2px">
                        匹配库存
                    </el-button>
                    <el-dropdown @command="(cmd)=> batchPrint(cmd)">
                        <el-button type="primary" size="medium" icon="el-icon-printer" color="#2b92f6" radius="2px">
                            批量打印
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="1">打印货单</el-dropdown-item>
                            <el-dropdown-item :command="5">货单&出货码</el-dropdown-item>
                            <el-dropdown-item :command="3">自定义单</el-dropdown-item>
                            <el-dropdown-item :command="4">货单&自定义</el-dropdown-item>
                            <el-dropdown-item :command="2">打印面单</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="batchUpdateRemark" color="#2b92f6" radius="2px">
                        批量更新报单备注
                    </el-button>
                </div>
                <div>
                    <label class="custom-radio" @click.prevent="onSortChange(0)">
                        <input type="radio" name="sortType" value="0" :checked="isSortChecked(0)">
                        <span class="custom-radio-btn">
                            按紧急程度排序
                            <span class="sort-icons" :class="sortIconClass(0)">
                                <span class="sort-triangle up"></span>
                                <span class="sort-triangle down"></span>
                            </span>
                        </span>
                    </label>
                    <label style="margin-left:2px;" class="custom-radio" @click.prevent="onSortChange(1)">
                        <input type="radio" name="sortType" value="1" :checked="isSortChecked(1)">
                        <span class="custom-radio-btn">
                            按下单时间排序
                            <span class="sort-icons" :class="sortIconClass(1)">
                                <span class="sort-triangle up"></span>
                                <span class="sort-triangle down"></span>
                            </span>
                        </span>
                    </label>
                </div>
            </div>
            <div style="width: 100%; height: 1px; margin-top: 15px; background: #f2f3ff;"></div>
            <div class="order-tabs">
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='13'?'pending':'shipping')}" 
                        @click="doNav('13')">
                    待备货
                </div>
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='15'?'pending':'shipping') }" 
                        @click="doNav('15')">
                    备货中
                </div>
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='20'?'pending':'shipping') }" 
                        @click="doNav('20')">
                    待打包
                </div>
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='23,25'?'pending':'shipping') }" 
                        @click="doNav('23,25')">
                    打包中
                </div>
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='79,80'?'pending':'shipping') }" 
                        @click="doNav('79,80')">
                    取消单
                </div>
                <div class="tab-item" 
                        :class="{ active: activeTab === (query.statusStr==='13,15,20,23,25'?'pending':'shipping') }" 
                        @click="doNav('13,15,20,23,25')">
                    全部
                </div>
            </div>
            <table :style="{ width: '100%', minWidth: '800px'}" style="flex-direction: column;">
                <tr style="background-color: #fff;">
                    <td style="width: 30%; min-width: 260px;">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <el-checkbox 
                                v-model="selectAll" 
                                @change="handleSelectAll"
                                :indeterminate="isIndeterminate">
                            </el-checkbox>
                            <span>商品信息</span>
                        </div>
                    </td>
                    <td style="width: 14%; min-width: 110px;">
                        <span>采购信息</span>
                    </td>
                    <td style="width: 14%; min-width: 110px;">
                        <span>备货信息</span>
                    </td>
                    <td style="width: 10%; min-width: 110px;">
                        <span>货态物流</span>
                    </td> 
                    <td style="width: 14%; min-width: 110px;">
                        <span>打包信息</span>
                    </td>
                    <td style="width: 10%; min-width: 80px;">
                        <span>金额信息</span>
                    </td>
                    <td style="width: 16%; min-width: 130px;">
                        <span>时效信息</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="data-row" v-for="(order, i) in orders" :key="i+1" style="margin: 0px 15px 15px 15px;">
            <table :style="{ width: '100%', minWidth: '800px'}">
                <tr>
                    <td colspan="6">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <!-- <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="buildPkg(order)">
                                <span>备货打包</span>
                            </button> -->
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="expPageView(order.details[0].pageId)">
                                <span>查看面单</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="batchSendOrder(order.stockId)">
                                <span>一键发货</span>
                            </button>
                            <!-- <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="refresh">
                                <span>更新订单</span>
                            </button> -->
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="doCancelStock(order.stockId)">
                                <span>取消订单</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="addDetail(order.details[0])">
                                <span>添加商品</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="doPrint(1,order.details[0])">
                                <span>打印货单</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="doPrint(3,order.details[0])">
                                <span>打印自定义单</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="doPrint(4,order.details[0])">
                                <span>打印货单&自定义</span>
                            </button>
                            <button class="ctrl-button" @mousedown="handleButtonMouseDown" @click="doPrint(5,order.details[0])">
                                <span>打印货单&出货码</span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr style="background-color: #fff;">
                    <td colspan="7">
                       <div style="display: flex; gap: 10px; align-items: center;font-size: 12px;">
                            <span>{{ order.details[0].code }}<i slot="suffix" class="el-input__icon el-icon-document-copy" style="cursor: pointer;" @click="copyCode(order.details[0].code)"></i></span>
                            <span style="color: #dcdfe6;">|</span>
                            <span>{{ order.details[0].orderStatus }}</span>
                            <span style="color: #dcdfe6;">|</span>
                            <span>{{ order.details[0].shopName }}</span>
                            <span style="color: #dcdfe6;">|</span>
                            <span>买家：{{ order.details[0].shopBuyer }}</span>
                            <span style="color: #dcdfe6;">|</span>
                            <span>买家留言：{{ order.details[0].shopSellerMsg }}</span>
                            <span style="color: #dcdfe6;">|</span>
                            <span style="font-size: 14px; color: red;">报单备注：{{ order.details[0].remark1 }}<i slot="suffix" class="el-input__icon el-icon-edit" style="cursor: pointer; color: red;" @click="updateRemark(order.details)"></i></span>
                       </div>
                    </td>
                </tr>
                <tr v-for="(detail, index) in order.details" :key="index" style="background-color: #fff;">
                    <td style="width: 30%; min-width: 170px;">
                        <div class="item1">
                            <span style="width: 100px; min-width: 100px; height: 150px; overflow: hidden; position: relative;">
                                <ConcurrencyImage  style="width: 100px; min-width: 100px; height: 100px" 
                                    :src="kit.api.imgView+detail.productThumb" 
                                    :preview-src-list="[kit.api.imgView+detail.productThumb]"
                                ></ConcurrencyImage>
                                <span>
                                    <!-- <i slot="suffix" class="el-icon-picture-outline" style="cursor: pointer;position: relative; top: 25px; left: -80px;color:#ffa211" @click="updateVariationSku(detail,1)"></i> -->
                                    <el-upload
                                        class="xm-upload"
                                        :action="upload"
                                        :show-file-list="false"
                                        :with-credentials="true"
                                        :on-success="(res) => handUploadSuccess(res, detail)"
                                    >
                                        <el-link :underline="false" type="success" icon="el-icon-picture" style="font-size:18px;left: 15px;"></el-link>
                                    </el-upload>
                                </span>
                                <span><i slot="suffix" class="el-icon-delete" style="cursor: pointer;position: relative; top: -22px; left: 50px;color:#ff4a57" @click="deleteDetail(detail)"></i></span>
                                <el-checkbox v-model="detail.selected"  style="position: absolute; top: 0px; left: 3px;"></el-checkbox>
                            </span>
                            <div class="product-info">
                                <div class="cell-1 product-row">
                                    <!-- <span class="product-title" @click="viewLink('https://xiapi.xiapibuy.com/product/'+detail.shopId+'/'+detail.productId)">{{ detail.productTitle }}</span> -->
                                    <div class="product-title-wrap" style="padding: 0px 0px; ">
                                        <el-link target="_blank" :underline="false" style="font-weight:bold;font-size:13px;white-space: normal;word-break: break-word;" 
                                            @click="viewLink(detail)" 
                                        >
                                            <span class="auto-break"> {{detail.productTitle}}</span>    
                                        </el-link>
                                    </div>
                                    <span class="product-qty" @click="updateQty(detail)"><span>x</span>{{ detail.productQty }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>商品ID：</span>
                                    <span>{{ detail.productId }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>规&nbsp;&nbsp;&nbsp;&nbsp;格：</span>
                                    <!-- <span><i slot="suffix" class="el-icon-edit" style="cursor: pointer;margin-right:5px;" @click="editProductSpec(detail)"></i></span> -->
                                    <template v-if="editingSpecId === detail.id">
                                        <div class="multi-line-ellipsis" style="padding: 0px 0px; ">
                                            <input 
                                                v-model="editingSpecValue" 
                                                class="canedit" 
                                                @blur="saveProductSpec(detail)" 
                                                @keyup.enter="saveProductSpec(detail)"
                                                @keyup.esc="cancelEditProductSpec"
                                                :ref="'specInput_' + detail.id"
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- <span>{{ detail.productSpec }}</span> -->
                                        <div class="product-spec-wrap" style="padding: 0px 0px; ">
                                            <el-link target="_blank" :underline="false" style="font-size:12px;white-space: normal;word-break: break-word;">
                                                <span class="auto-break"> {{detail.productSpec}}</span>    
                                            </el-link>
                                        </div>
                                    </template>
                                </div>
                                <div class="cell-1">
                                    <span>S&nbsp;&nbsp;K&nbsp;&nbsp;U：</span>
                                    <span><i slot="suffix" class="el-icon-edit" style="cursor: pointer;margin-right:5px;" @click="updateVariationSku(detail,0)"></i></span>
                                    <!-- <span>{{ detail.sku }}</span> -->
                                    <div class="sku-wrap" style="padding: 0px 0px; ">
                                        <el-link target="_blank" :underline="false" style="font-size:12px;white-space: normal;word-break: break-word;">
                                            <span class="auto-break"> {{detail.sku}}</span>    
                                        </el-link>
                                    </div>
                                </div>
                                <div class="cell-1">
                                    <span>货&nbsp;&nbsp;&nbsp;&nbsp;号：</span>
                                    <span><i slot="suffix" class="el-icon-edit" style="cursor: pointer;margin-right:5px;" @click="updateVariationSku(detail,1)"></i></span>
                                    <!-- <span>{{ detail.variationSku }}</span> -->
                                    <el-tooltip class="item" effect="dark" :content="detail.variationSku" placement="top-start">
                                        <div class="multi-line-ellipsis" style="padding: 0px 0px; ">
                                            <el-link target="_blank" :underline="false" style="font-size:12px;">
                                                <span class="auto-break"> {{detail.variationSku}}</span>    
                                            </el-link>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <div class="cell-1">
                                    <span>单价<span style="font-size: 10px;">TWD</span>：</span>
                                    <span>{{ detail.productPrice > 0 ? (detail.productPrice / 100).toFixed(2) : ''  }}</span>
                                </div>
                                <div class="cell-1">
                                    <span>成本<span style="font-size: 10px;">CNY</span>：</span>
                                    <span><i slot="suffix" class="el-icon-edit" style="cursor: pointer;margin-right:5px;" @click="doUpdateCost(detail)"></i></span>
                                    <span>{{ detail.cost > 0 ? (detail.cost / 100).toFixed(2) : ''  }}</span>
                                </div>
                            </div>
                        </div> 
                    </td>
                    <td style="width: 14%; min-width: 110px;">
                        <div v-if="!detail.purchaseCode" class="ctrl-cell">
                            <div v-if="detail.hasLink > 0" style="color: #ff4a57;" @click="handlePurchase(detail)">
                                <i class="iconfont" >&#xe67b;</i>
                                <span>一键采购</span>
                            </div>
                            <div v-else style="color: #c0c4cc; cursor: not-allowed;" @click="handlePurchaseSim(detail)">
                                <i class="iconfont" >&#xe67b;</i>
                                <span>一键采购</span>
                            </div>
                            <div v-if="detail.showOrderedStatus">
                                <span v-if="detail.orderedStatus==1" class="purchase-status-ok">{{detail.orderedMsg}}</span>
                                <span v-if="detail.orderedStatus==0" class="purchase-status-error">{{detail.orderedMsg}}</span> 
                            </div>

                            <div v-if="detail.hasLink > 0" style="color:#ffa211;" @click="openGoodsLink(detail,1)">
                                <i class="iconfont" >&#xe6b0;</i>
                                <span>编辑货源</span>
                            </div>
                            <div v-else style="color:#ffa211;" @click="openGoodsLink(detail,0)">
                                <i class="iconfont" >&#xe704;</i>
                                <span>关联货源</span>
                            </div>
                            <div style="color: #2b92f6;" @click="updatePurchaseCode(detail)">
                                <i class="iconfont" >&#xe604;</i>
                                <span>添加采购单</span>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="detail.purchaseTime" class="cell-2">采购时间：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span>{{ detail.purchaseTime }}</span>
                                </div>
                            </div>
                            <div v-if="detail.purchasePlatform" class="cell-2">采购平台：<el-link @click="openGoodsLink(detail,1)" :underline="false">{{ getPurchasePlatform(detail) }}</el-link></div>
                            <!-- <div class="cell-3">
                                <div class="cell-4">
                                    <span>{{ getPurchasePlatform(detail) }}</span>
                                </div>
                            </div> -->
                            <div class="cell-2"><span style="color:#2b92f6">采购单号：</span>
                                <el-link style="margin-left:10px;" :underline="false" type="primary" @click="updatePurchaseCode(detail)" title="保存采购单号">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                                <el-link v-if="detail.purchaseCode" style="margin-left:10px;" :underline="false" type="danger" @click="rebackPurchaseCode(detail)" title="撤销采购单号">
                                    <i class="el-icon-delete"></i>
                                </el-link>
                            </div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color:#e6a23c;">{{ detail.purchaseCode }}</span>
                                </div>
                            </div>
                            <!-- <div class="cell-2">快递单号：
                                <el-link v-if="detail.innerExpCode" :underline="false">
                                    <i class="el-icon-document-copy" @click="copyCode(detail.innerExpCode)"></i>
                                </el-link>
                                <el-link style="margin-left:10px;" :underline="false" type="primary" @click="updateCode(detail)" title="更新快递单号">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                                <el-link v-if="detail.innerExpCode" style="margin-left:10px;" :underline="false" type="danger" @click="deleteInnerCode(detail)" title="删除快递单号">
                                    <i class="el-icon-delete"></i>
                                </el-link>
                            </div>
                            <div class="cell-3">
                                <div class="cell-4" v-if="detail.innerExpCode">
                                    <a target="_blank" :href="'https://www.baidu.com/s?wd='+detail.innerExpCode"><i class="el-icon-link"></i></a>
                                    <span style="color:#e6a23c;">{{ detail.innerExpCode }}</span>
                                </div>
                            </div> -->
                        </div>
                    </td>
                    <td style="width: 14%; min-width: 110px;">
                        <div>
                            <div class="ctrl-cell" style="padding: 5px;">
                                <el-checkbox v-model="detail.mark"
                                    @change="(val) => updateMark(detail,val)"
                                    :true-label="1"
                                    :false-label="0">
                                </el-checkbox>
                                {{msg('点到')}}
                            </div>
                            <div v-if="!detail.innerExpCode" class="ctrl-cell">
                                <div style="color: #5daf34;"  @click="updateCode(detail)">
                                    <i class="iconfont" >&#xe621;</i>
                                    <span>添加快递单号</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="cell-2">快递单号：
                                    <el-link v-if="detail.innerExpCode" :underline="false">
                                        <i class="el-icon-document-copy" @click="copyCode(detail.innerExpCode)"></i>
                                    </el-link>
                                    <el-link style="margin-left:10px;" :underline="false" type="primary" @click="updateCode(detail)" title="更新快递单号">
                                        <i class="el-icon-edit-outline"></i>
                                    </el-link>
                                    <el-link v-if="detail.innerExpCode" style="margin-left:10px;" :underline="false" type="danger" @click="deleteInnerCode(detail)" title="删除快递单号">
                                        <i class="el-icon-delete"></i>
                                    </el-link>
                                </div>
                                <div class="cell-3">
                                    <div class="cell-4" v-if="detail.innerExpCode">
                                        <a target="_blank" :href="'https://www.baidu.com/s?wd='+detail.innerExpCode"><i class="el-icon-link"></i></a>
                                        <span v-if="detail.shelfCode" style="color:#409EFF;">{{ detail.innerExpCode }}</span>
                                        <span v-else style="color:#e6a23c;">{{ detail.innerExpCode }}</span>
                                    </div>
                                </div>
                                <div v-if="detail.shelfCode" class="cell-2">存储架位：</div>
                                <div v-if="detail.shelfCode" class="cell-3">
                                    <div class="cell-4">
                                        <span style="color: #3a8ee6; font-weight: bold;">{{ detail.shelfCode }}</span>
                                    </div>
                                </div>
                                <div v-if="detail.upperDate" class="cell-2">上架时间：</div>
                                <div v-if="detail.upperDate" class="cell-3">
                                    <div class="cell-4">
                                        <span>{{ detail.upperDate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="width: 10%; min-width: 80;vertical-align: middle;text-align:center;"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span>
                                        <!-- <el-tag effect="plain" style="cursor: pointer;" :type="getStatusType(detail)" size="mini" @click="$refs.traceRef.showTracks(detail.stockId, 0);">{{ getStatus(detail) }}</el-tag> -->
                                        <el-button size="mini" @click="$refs.traceRef.showTracks(detail.stockId, 0);" style="cursor: pointer;" :type="getStatusType(detail)">{{ getStatus(detail) }}</el-button>
                                    </span>
                                </div>
                            </div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color:#5daf34">{{ getExpGoodType(detail) }}</span>
                                </div>
                            </div>
                            <div class="cell-2">配送方式</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color:#5daf34">{{ detail.expCompany }}</span>
                                </div>
                            </div>
                            <div v-if="detail.transport" class="cell-2">运输方式</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color:#ffa211">{{ detail.transport }}</span>
                                </div>
                            </div>
                            <div v-if="detail.expCod==1" class="cell-2">付款方式</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color:#ffa211">{{ detail.expCod==1?'货代付款':'' }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="width: 14%; min-width: 80px;vertical-align: middle;text-align:center;"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div class="cell-3">
                                <div class="cell-4" >
                                    <span style="color: #3a8ee6; font-weight: bold;">
                                        {{ getExpPkgType(detail) }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="detail.storeName" class="cell-2">仓库</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color: #3a8ee6; font-weight: bold;">
                                        {{ detail.storeName  }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="detail.packageTime" class="cell-2">通知打包时间</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.packageTime }}
                                </div>
                            </div>
                            <div v-if="detail.orderCode" class="cell-2">打单时间</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.orderCode }}
                                </div>
                            </div>
                            <div v-if="detail.errMsg" class="cell-2">异常说明</div>
                            <div class="cell-3">
                                <div class="cell-4" >
                                    <span style="color: #f56c6c; font-weight: bold;">
                                        {{ detail.errMsg }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="width: 10%; min-width: 80px;vertical-align: middle;"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div class="cell-2">订单金额<span style="font-size: 10px;">TWD</span>：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    <span style="color: #e6a23c; font-weight: bold;">
                                        {{ detail.amtOrder > 0 ? (detail.amtOrder / 100).toFixed(2) : '0'  }}
                                    </span>
                                </div>
                            </div>
                            <div class="cell-2">预估进账<span style="font-size: 10px;">TWD</span>：</div>
                            <div class="cell-3">
                                <div class="cell-4" style="width: 50px;">
                                    <span style="color: #e6a23c; font-weight: bold;">
                                        {{ detail.escrowAmount }}
                                    </span>
                                </div>
                            </div>
                            <div class="cell-2">总成本<span style="font-size: 10px;">CNY</span>：</div>
                            <!-- <span><i slot="suffix" class="el-icon-view" style="cursor: pointer;margin-right:5px;" @click="doUpdateCost(detail)"></i></span> -->
                            <div class="cell-3">
                                <div class="cell-4" style="width: 50px;">
                                    <el-link :underline="false" @click="checkCost(order, detail)"><span style="color: rgb(60 181 230); font-weight: bold; text-decoration: underline;">{{ getSumCost(order,detail) }}</span></el-link>
                                </div>
                            </div>
                            <div class="cell-2">预估利润<span style="font-size: 10px;">CNY</span>：</div>
                            <div class="cell-3">
                                <div class="cell-4" style="width: 50px;">
                                    <span style="color: red; font-weight: bold;">
                                        {{ getSumProfit(order,detail) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td style="width: 16%; min-width: 130px;vertical-align: middle;"
                        v-if="index == 0" :rowspan="order.details.length">
                        <div>
                            <div v-if="order.balanceTime" class="cell-2">发货剩余：</div>
                            <div v-if="order.balanceTime" class="cell-3">
                                <div style="color: #cd1b1b;">
                                    <i class="iconfont" >&#xe66b;</i>
                                    <span>{{ order.balanceTime }}</span>
                                </div>
                            </div>
                            <div class="cell-2">下单时间：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.created }}
                                </div>
                            </div>
                            <div class="cell-2">最后出货时间：</div>
                            <div class="cell-3">
                                <div class="cell-4">
                                    {{ detail.shopDayToShip }}
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div><!--end data-row-->
    </div><!--end table-wrap-->

    <pagenator @page-change="handlerPageChange" :query="query" class="pagenator" style="padding: 10px 0px;" >
    </pagenator>
     <!--打印-->
     <stock-print :print-ctrls="printCtrls" ref="printDg" @print-finish = "getData"/>
     <!--自定义打印-->
     <print-custom-dialog ref="PrintCustomDialogRef" />
     <!--打印拣货单&自定义快递单-->
    <stock-print4 :print-ctrls="printCtrls" ref="printDg4" />
     <!--打印货单&出货码-->
    <stock-print3 :print-ctrls="printCtrls" ref="printDg3" />
    <!--自定义快递单-->
    <stock-print6 :print-ctrls="printCtrls" ref="printDg6" />

    <!--备货打包-->
    <order-pkg-dialog ref="OrderPkgDialogRef" @finish="getData"/>
     <buy-dialog ref="BuyDialogRef" @finish="getData"/>
      <!--添加详情-->
     <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="getData"/>
     <!--采购弹窗-->
    <order-finish-buy ref="purchasDg" :stocks="selectedStocks" @finish="getData"/>
    <!--同步店铺订单-->
    <sync-order ref="SyncOrderRef" :is-min-screen="isMinScreen"/>
    <!--更新成本-->
    <cost-update-dialog ref="CostUpdateDialogRef" @finish="getData"/>
    <sku-update-dialog ref="SkuUpdateDialogRef" @finish="getData"/>
    <!--物流查詢-->
    <trace ref="traceRef"></trace>
    <!--快递同步-->
    <sync-express ref="SyncExpressDialogRef" @refresh="refreshSyncButton" @finish="doSyncExpress"/>
    <!--成本查看-->
    <cost-view-dialog ref="CostViewDialogRef" />

    <el-dialog
        :title="msg('导入采购链接')" :fullscreen="isMinScreen"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        :before-close="doCloseImport"
        width="60%">
            <purchase-import @close-dg="importVisible=false"/>
    </el-dialog>

    <el-dialog :title="msg('查看面单')" :close-on-click-modal="false" 
        :visible.sync="imgVisiable" width="800px"
        :fullscreen="isMinScreen">
            <page-view :imgId="pageId" @close-dg="imgVisiable = false" />
    </el-dialog>

    <el-dialog :title="goodsTitle" :visible.sync="linkVisible" @opened="openLinkDg"
        :close-on-click-modal="false" width="800px" :append-to-body="true"
    >
        <order-goods-link :goodsDetail="goodsDetail" ref="dgLinkRef" @close-dg="closeGoodsLinkDg"/>
    </el-dialog>

    <el-dialog
        :title="msg('采购信息')"
        :visible.sync="purchaseCodevisible"
        :close-on-click-modal="false"
        size="mini"
        width="600px"
    >
        <el-form ref="form" label-width="100px">
            <el-form-item :label="msg('采购单号：')">
                <el-input v-model="purchaseCode" :placeholder="msg('请输入采购单号')">
                    <el-button slot="append" icon="el-icon-search" @click="showSearchPurchaseCodeDialog">选择历史订单</el-button>
                </el-input>
            </el-form-item>
            <el-form-item :label="msg('采购平台：')">
                <el-select v-model="purchasePlatform" clearable :placeholder="msg('请选择')">
                    <el-option v-for="d in options" 
                        :label="d.label" :value="d.value" :key="d.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="msg('采购单价：')">
                <el-input-number v-model="purchaseAmount" :min="0" :placeholder="msg('采购单价')">
                </el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="purchaseCodevisible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="savePurchaseCode()">{{msg("确定")}}</el-button>
        </span>
    </el-dialog>

    <!--选择采购单号-->
    <search-purchase-code-dialog ref="SearchPurchaseCodeDialogRef" @finish="finishSearchPurchaseCode"/>
</div>
</template>

<script>
// import {_axios as axios} from  "../../plugins/axios.js";
import axios from "axios";
import Pagenator from "../../components/PaginationSimple.vue";
import StockPrint from "../store/StockPrint.vue";
import StockPrint3 from "../store/StockPrint3.vue";
import StockPrint4 from "../store/StockPrint4.vue";
import StockPrint6 from "../store/StockPrint6.vue";
import PrintCustomDialog from "../print/PrintCustomDialog.vue";
import OrderService from "./OrderService.js"
import BuyDialog from "./BuyDialog.vue"
import OrderStep from "./OrderStep.vue"
import OrderQuery from "./OrderQuery.vue"
import CostUpdateDialog from "./CostUpdateDialog.vue"
import OrderFinishBuy from "./OrderFinishBuy.vue";
import StockDetailService from '../store/StockDetailService.js';
import PurchaseImport from "../purchase/PurchaseImport.vue";
import AddStockDetailDialog from "./AddStockDetailDialog.vue"
import OrderPkgDialog from "./OrderPkgDialog.vue"
import SyncOrder from "../store/StockSyncOrder.vue";
import SkuUpdateDialog from "./SkuUpdateDialog.vue"
import Trace from "../store/StockTrace.vue";
import OrderGoodsLink from "./OrderGoodsLink.vue"
import SyncExpress from "./SyncExpress.vue";
import CostViewDialog from "./CostViewDialog.vue";
import SearchPurchaseCodeDialog from "./SearchPurchaseCodeDialog.vue"
import {
openWindowWithPost,
batchSendOrderNew,
trackExpress
} from "../store/StockService.js";

export default {
    name: "Order1",
    components: {
        Pagenator:Pagenator,
        StockPrint: StockPrint,
        BuyDialog: BuyDialog,
        OrderFinishBuy: OrderFinishBuy,
        PurchaseImport: PurchaseImport,
        AddStockDetailDialog: AddStockDetailDialog,
        OrderStep: OrderStep,
        OrderQuery: OrderQuery,
        SyncOrder: SyncOrder,
        PrintCustomDialog: PrintCustomDialog,
        StockPrint4: StockPrint4,
        StockPrint3: StockPrint3,
        CostUpdateDialog: CostUpdateDialog,
        SkuUpdateDialog: SkuUpdateDialog,
        Trace: Trace,
        OrderGoodsLink: OrderGoodsLink,
        StockPrint6:StockPrint6,
        OrderPkgDialog:OrderPkgDialog,
        SyncExpress:SyncExpress,
        CostViewDialog:CostViewDialog,
        SearchPurchaseCodeDialog:SearchPurchaseCodeDialog,
    },
    mounted: function(){
        this.user  = JSON.parse(localStorage.getItem("user"));
        this.getUserSetting();
        this.$nextTick(() => {
            if(this.$refs.orderQueryRef && this.$refs.orderQueryRef.query){
                const q = this.$refs.orderQueryRef.query;
                if(q.length === undefined) this.$set(q, 'length', 10);
                if(q.start === undefined) this.$set(q, 'start', 0);
                if(q.pageIndex === undefined) this.$set(q, 'pageIndex', 1);
                if(q.pageTotal === undefined) this.$set(q, 'pageTotal', 0);
                this.query = q;
            }
            this.getData();
        });
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                        binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        orderInfoWindowId: { //订单详情窗口id
            get() {
                var is = this.$store.state.orderInfoWindowId;
                return is;
            }
        }, 
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 260;
            }
        }
    },
    data(){
        return {
            query: {
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,

                code: '',
                innerExpCode: '',
                purchaseCode: '',
                status: '',
                shopName: '',
                LastDate: '',
                Date: [],
                codeType: 3,

                isPurchase: null,//是否采购
                isBuyLink: null,//有无链接
                isSend: null,//上家是否发货
                remark: null,//备注
                remainTime: null,//剩余发货时间
                expCod:null,//付款方式 1 货到付款 3 纯配送
                isCancel: false,//取消单
                isPay: false,//货到付款
                sortType: null,//排序类型
                PurchaseDate: [],//采购时间
            },
            showQuery: false,
            upload: this.$kit.api.upload+"?type=product&auth=1",
            orders: [],
            printCtrls: [],
            selectedStocks: [],
            importVisible: false,
            user: null,
            imgVisiable: false,
            pageId: null,
            activeTab: 'pending',
            selectAll: false,
            isIndeterminate: true,
            linkVisible: false,
            goodsTitle:null,
            goodsType:null,
            goodsDetail:null,
            purchaseCodevisible: false,
            purchaseCode:null,
            purchasePlatform:null,
            purchaseAmount:0,
            selectedDetail:null,
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ],
            editingSpecId: null, // 正在编辑的规格ID
            editingSpecValue: '', // 正在编辑的规格值
            originalSpecValue: '', // 原始规格值
            isSyncExpressDisabled: false, // 新增按钮禁用状态
            costSetting: {
                rate: 4.5, // 参考汇率
                expCost: 0, // 运费成本
                dabaoCost: 0, // 打包成本
                jindianCost: 0, // 进店成本
                otherCost: 0, // 其他成本
            },
        }
    },
    methods: {
        searchFromHeader(){
            if(this.$refs.orderQueryRef && this.$refs.orderQueryRef.search){
                this.$refs.orderQueryRef.search();
                return;
            }
            this.getData(true);
        },
        reset() {
            this.$kit.clearQuery(this.query);
        },
        doChangeShop(shopName){
            this.query.shopName = shopName;
        },
        doSearch(query){
            this.query = query;
            this.getData(true);
        },
        copyCode(code){
            if (navigator.clipboard) {
                navigator.clipboard.writeText(code)
                    .then(() => {
                        this.$message.success('复制成功');
                    })
                    .catch((err) => {
                        console.error('复制失败: ', err);
                        this.$message.error('复制失败');
                    });
            } else {
                this.$message.error('当前浏览器不支持剪贴板功能');
            }
        },
        doNav(statusStr){
            this.query.statusStr = statusStr;
            if (statusStr == '-1') {
                this.query.status = [];
            }else{
                this.query.status = statusStr.split(',')
                .map(function(item) {
                    return Number(item); // 或者使用加号：return +item;
                });
            }
            
            this.getData(true);
        },
        onSortChange(value) {
            const state = this.sortState(value);
            if (state === 'none') {
                this.query.sortType = value;
            } else if (state === 'asc') {
                this.query.sortType = value === 0 ? 2 : 3;
            } else {
                this.query.sortType = null;
            }
            this.getData(true);
        },
        sortState(value) {
            const t = this.query.sortType === null || this.query.sortType === undefined ? null : Number(this.query.sortType);
            if (value === 0) {
                if (t === 0) return 'asc';
                if (t === 2) return 'desc';
                return 'none';
            }
            if (value === 1) {
                if (t === 1) return 'asc';
                if (t === 3) return 'desc';
                return 'none';
            }
            return 'none';
        },
        isSortChecked(value) {
            return this.sortState(value) !== 'none';
        },
        sortIconClass(value) {
            return this.sortState(value);
        },
        getUserSetting() {
            axios.request({
                url: this.$kit.api.user.settingList+"?xgroup=COST_GROUP", 
                method: 'get',
                headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                withCredentials: true,
            }).then((result) => {
                if (result.status) {
                    let data = result.data.data;
                    if (data.length > 0) {
                        let cost = JSON.parse(data[0].xvalue);
                        this.costSetting.expCost = Number(cost.expCost) || 0;
                        this.costSetting.dabaoCost = Number(cost.dabaoCost) || 0;
                        this.costSetting.jindianCost = Number(cost.jindianCost) || 0;
                        this.costSetting.otherCost = Number(cost.otherCost) || 0;
                        this.costSetting.rate = Number(cost.rate) || 4.5;
                        // this.checkAutoSyncExpressSchedule();
                    }
                }
            });
        },
        getData(refresh) {
            let param = null;

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
                this.query.length = 10;
                // this.selectedRows = [];
            }

            this.query['codeType'] = 3;
            param = this.$kit.rebuildQuery(this.query, ['Date', 'LastDate', 'PurchaseDate']);
            if(param.status && param.status.length>0){
                param.status = param.status.join(",")
            }
            // else{
            //     param.status = '13';
            // }
            var _this = this;
            this.$axios.post(
                this.$kit.api.stockDetail.listByStockNew, 
                param
            ).then((result) => {
                if(result.status){
                    let list = result.data.list;
                    this.orders = [];
                    let dataMap = {};
                    // 用于记录 stockId 首次出现的顺序
                    let stockIdOrder = []; 

                    if(list && list.length > 0){
                        list.forEach(d => {
                            if(!dataMap[d.stockId]){
                                dataMap[d.stockId] = [];
                                stockIdOrder.push(d.stockId);
                            }
                            dataMap[d.stockId].push(d);
                        });
                        // 按照 stockId 首次出现的顺序处理
                        stockIdOrder.forEach(key => {
                            let balanceTime = null; 
                            let shopDayToShip = dataMap[key][0].shopDayToShip;
    
                            if(shopDayToShip){
                                let diff = new Date(shopDayToShip) - new Date();
                                if(diff <= 0){
                                    balanceTime = '0天0小时0分钟';
                                }else{
                                    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
                                    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                                    balanceTime = `${days}天${hours}小时${minutes}分钟`;
                                }
                            }
    
                            dataMap[key].forEach(d => {
                                d.selected = false;
                                d.showOrderedStatus = false;
                                d.orderedStatus = null;
                                d.orderedMsg = null;
                            });
                            
                            this.orders.push({
                                stockId: key,
                                balanceTime: balanceTime,
                                details: dataMap[key]
                            });
    
                        });
                        const checkParams = [];
                        this.orders.forEach(order => {
                            order.details.forEach(d => {
                                if(d.hasLink == 0){
                                    checkParams.push({
                                        id: d.id,
                                        productId: d.productId,
                                    });
                                }
                            });
                        });
                        if(checkParams.length > 0){
                            //这里重新查询一次是否有采购链接，把没有采购链接的数据进行查询
                            axios.request({
                                url: this.$kit.api.stockDetail.checkBuyLink,
                                method: 'post',
                                data: checkParams,
                                headers: {"Content-Type":"application/json; charset=utf-8",
                                    "X-Requested-With":"XMLHttpRequest",
                                },
                                withCredentials: true,
                            }).then((result) => {
                                const body = result && result.data;
                                const res = body && body.data ? body.data : body;
                                if(!res || !Array.isArray(res) || res.length === 0){
                                    return;
                                }
                                const hasLinkMap = new Map();
                                res.forEach(e => {
                                    if(e && e.id != null && e.hasLink == 1){
                                        hasLinkMap.set(e.id, 1);
                                    }
                                });
                                if(hasLinkMap.size === 0){
                                    return;
                                }
                                this.orders.forEach(order => {
                                    order.details.forEach(d => {
                                        if(d.hasLink == 0 && hasLinkMap.get(d.id) === 1){
                                            d.hasLink = 1;
                                        }
                                    });
                                });
                            });
                        }
                    }
                    // _this.query.pageTotal = result.data.total;
                    // _this.query = {..._this.query, pageTotal: result.data.total};
                    
                    if(refresh || _this.query.start == 0){
                        axios.request({
                            url: this.$kit.api.stockDetail.listByStock1Total,
                            method: 'post',
                            data: param,
                            headers: {"Content-Type":"application/json; charset=utf-8",
                                "X-Requested-With":"XMLHttpRequest",
                            },
                            withCredentials: true,
                        }).then((result) => {
                            let res = result.data;
                            if(res.status){
                                let total = res.data;
                                // console.log("总条数为："+total);
                                // this.query.pageTotal = total;
                                _this.query = {..._this.query, pageTotal: total};
                            }
                        });
                    }

                }
            });

        },
        handlePurchase(detail){
            console.log("111");
            //检测是否是最新版本插件
            /* global chrome */
            const extId = document.body.getAttribute('ba-ext-id');
            if(extId && window.chrome && chrome.runtime){
                let responded = false;
                const timeoutId = setTimeout(() => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    this.$message("请先更新插件到最新版本");
                }, 1000);
                console.log('当前时间'+new Date().toLocaleString());
                chrome.runtime.sendMessage(extId, {
                    action: 'getVersion',
                }, response => {
                    console.log('当前时间'+new Date().toLocaleString());
                    console.log('插件版本'+response);
                    if(responded){
                        return;
                    }
                    responded = true;
                    clearTimeout(timeoutId);
                    if (chrome.runtime.lastError) {
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                    if (response && response.data) {
                        const version = response.data;
                        console.log('当前插件版本'+version);
                        if(this.$kit.compareVersion(version, this.dicts.chromeVersion) < 0){
                            this.$message("插件版本过低，请移除后下载安装最新版本");
                            return;
                        }else{
                            this.doHandlePurchase(detail);
                        }
                    }else{
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                });
            }else{
                this.$message("插件版本过低，请移除后下载安装最新版本");
                return;
            }
        },
        // 采购
        doHandlePurchase(detail){
            var _this = this;
            let selectes = [detail];
            //通过sku、货号去匹配采购链接，如果获取到则直接跳转
            this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
            OrderService.concatPurchaseLink(selectes).then((links) => {
                if(links.length == 1){
                    this.doChromeBuy(links[0],detail);
                    return;
                }
                let para = {
                    link: this.purchaseLink || null,
                    detailIds: [detail.id],
                    stockIds:  [detail.stockId],
                };
                this.$axios.post(
                    this.$kit.api.stockDetail.openBuyLinks,
                    para
                ).then((result) => {
                    if(result.status){
                        _this.doChromeBuy(result.data,detail);
                    }
                });
            });
        },
        handlePurchaseSim(detail){
            //检测是否是最新版本插件
            /* global chrome */
            const extId = document.body.getAttribute('ba-ext-id');
            if(extId && window.chrome && chrome.runtime){
                let responded = false;
                const timeoutId = setTimeout(() => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    this.$message("请先更新插件到最新版本");
                }, 1000);
                chrome.runtime.sendMessage(extId, {
                    action: 'getVersion',
                }, response => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    clearTimeout(timeoutId);
                    if (chrome.runtime.lastError) {
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                    if (response && response.data) {
                        const version = response.data;
                        if(this.$kit.compareVersion(version, this.dicts.chromeVersion) < 0){
                            this.$message("插件版本过低，请移除后下载安装最新版本");
                            return;
                        }else{
                            this.doHandlePurchaseSim(detail);
                        }
                    }else{
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                });
            }else{
                this.$message("插件版本过低，请移除后下载安装最新版本");
                return;
            }
        },
        doHandlePurchaseSim(detail){
            var _this = this;
            let selectes = [detail];
            //通过sku、货号去匹配采购链接，如果获取到则直接跳转
            this.selectedStocks = selectes.map(s => {return {stockId: s.stockId, detailId: s.id, qty: s.productQty}});
            OrderService.concatPurchaseLink(selectes).then((links) => {
                if(links.length == 1){
                    this.doChromeBuy(links[0],detail);
                    return;
                }
                this.openGoodsLink(detail,0);
            });
        },
        doChromeBuy(link, detail){
            var _this = this;
            if(!link){
                return;
            }
            OrderService.chromeBuy(link, detail, (response)=>{
                if (response.success && response.data.orderId) {
                    detail.showOrderedStatus = true;
                    detail.orderedStatus = 1;
                    detail.orderedMsg = '采购成功';
                } else {
                // _this.$message("采购失败，请检查插件是否安装或启用");
                    detail.showOrderedStatus = true;
                    detail.orderedStatus = 0;
                    detail.orderedMsg = response.error || "采购失败";
                }
            }, (result)=> {
                if(result.status){
                    this.getData();
                }
            });
        },
        //批量采购
        batchBuy(){
            if(this.user.deptPath.indexOf('/1/6262/2') > -1){
                //圣捷下面的客户只需要有会员就可以
                if(!this.user.vip || this.user.vip == 0){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }else{
                if(!this.hasPermission("stock:detailPurchase")){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }
            //检测是否是最新版本插件
            /* global chrome */
            const extId = document.body.getAttribute('ba-ext-id');
            if(extId && window.chrome && chrome.runtime){
                let responded = false;
                const timeoutId = setTimeout(() => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    this.$message("请先更新插件到最新版本");
                }, 1000);
                chrome.runtime.sendMessage(extId, {
                    action: 'getVersion',
                }, response => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    clearTimeout(timeoutId);
                    if (chrome.runtime.lastError) {
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                    if (response && response.data) {
                        const version = response.data;
                        if(this.$kit.compareVersion(version, this.dicts.chromeVersion) < 0){
                            this.$message("插件版本过低，请移除后下载安装最新版本");
                            return;
                        }else{
                            this.$confirm('会员功能，限时试用！', this.msg('提示'), {
                                confirmButtonText: this.msg('确认'),
                                cancelButtonText: this.msg('取消'),
                                type: 'warning'
                            }).then(() => {
                                var selectes = this.getSelected();
                                if(selectes.length == 0){
                                    this.$message(this.msg('请选中一条数据进行操作'));
                                    return;
                                }
                                axios.request({
                                    url: this.$kit.api.history.create+'?t=批量采购',
                                    method: 'get',
                                    headers: {"Content-Type":"application/json; charset=utf-8",
                                        "X-Requested-With":"XMLHttpRequest",
                                    },
                                    withCredentials: true,
                                }).then((result) => {
                                });
                                let detailLinks = [];
                                this.checkBuyLink(selectes, detailLinks).then(() => {
                                    this.doBatchBuy(detailLinks, selectes, 0, ()=>{});
                                });
                            }).catch((err) => {
                            });
                        }
                    }else{
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                });
            }else{
                this.$message("插件版本过低，请移除后下载安装最新版本");
                return;
            }
        },
        doBatchBuy(detailLinks, selectes, index=0, done=()=>{}){
            if(!selectes || selectes.length === 0){
                done();
                return;
            }
            if(index >= selectes.length){
                done();
                return;
            }
            const selected = selectes[index];
            const next = () => this.doBatchBuy(detailLinks, selectes, index+1, done);
            OrderService.concatPurchaseLink([selected]).then((links) => {
                if(links.length === 1){
                    OrderService.chromeBuy(links[0], selected, (result)=>{
                        if(result && result.status){
                            this.getData();
                        }
                        next();
                    });
                }else{
                    this.checkNeedBuy(detailLinks, selected, next);
                }
            });
        },
        checkNeedBuy(detailLinks, selected, callback){
            let link = detailLinks.find(l => l.id == selected.id);
            if(link){
                OrderService.chromeBuy(link.link, selected, (result)=>{
                    if(result && result.status){
                        this.getData();
                    }
                    if(callback){
                        callback();
                    }
                });
            }else{
                if(callback){
                    callback();
                }
            }
        },
        checkBuyLink(selectes, detailLinks = [], index = 0){
            if(!selectes || selectes.length === 0){
                return Promise.resolve(detailLinks);
            }
            if(index >= selectes.length){
                return Promise.resolve(detailLinks);
            }
            const selected = selectes[index];
            const para = {
                link: null,
                detailIds: [selected.id],
                stockIds:  [selected.stockId]
            };
            return this.$axios.post(
                this.$kit.api.stockDetail.openBuyLinks,
                para
            ).then((result) => {
                if(result && result.status){
                    detailLinks.push({
                        id: selected.id,
                        link: result.data,
                    });
                }
                return this.checkBuyLink(selectes, detailLinks, index + 1);
            }).catch(() => {
                return this.checkBuyLink(selectes, detailLinks, index + 1);
            });
        },
        //关联货源&编辑货源
        openGoodsLink(detail,type){
            this.goodsTitle = type == 1 ? "编辑货源" : "关联货源";
            this.goodsType = type;
            this.goodsDetail = detail;
            this.linkVisible = true;
        },
        openLinkDg(){
            this.$nextTick(() => {
                this.$refs.dgLinkRef.init(this.goodsType);
            });
        },
        closeGoodsLinkDg(){
            this.linkVisible = false;
            this.getData();
        },
        viewLink(detail){
            let link = '';
            const shopIdStr = detail.shopId == null ? '' : String(detail.shopId);
            if(shopIdStr.length >= 13){
                link = 'https://www.tw.coupang.com/vp/products/'+detail.productId;
            }else{
                link = 'https://xiapi.xiapibuy.com/product/'+detail.shopId+'/'+detail.productId;
            }

            this.$confirm(link, '产品链接：', {
                confirmButtonText: '打开',
                cancelButtonText: '复制产品ID',
                type: 'warning'
            }).then(() => {

                window.open(link, "_blank");

            }).catch(() => {
                // window.navigator.clipboard.writeText(link)
                // 创建一个临时的文本区域
                const tempInput = document.createElement('textarea');
                // 设置要复制的文本内容
                let productId  = link.substring(link.lastIndexOf('/')+1);
                tempInput.value = productId;
                tempInput.style="opacity:0;"
                // 追加到 body 中
                document.body.appendChild(tempInput);
                // 选中文本
                tempInput.select();
                // 执行复制操作
                document.execCommand('copy');
                // 移除临时文本区域
                document.body.removeChild(tempInput);
                this.$message("成功");
            });
        },
        //图片上传的回调函数
        //图片上传成功后将id设置到详情中
        handUploadSuccess(result, detail){
            StockDetailService.uploadProductPhotoCallback(
                result,
                detail.id,
                ()=>{
                    detail.productThumb = result.data;
                }    
            );
        },
        //新增一条详情
        addDetail(detail){
            let stock = {id:detail.stockId, status: detail.status};
            this.$refs.AddStockDetailDialogRef.showDialog({
                stockId: stock.id,
                status: stock.status
            });
        },
        //删除详情
        deleteDetail(detail){
            OrderService.deleteDetail({id: detail.id, status: detail.status}, this.getData);
        },
        //报单备注
        updateRemark(selectes){
            OrderService.updateRemark(1, selectes, this.getData);
        },
        batchUpdateRemark(){
            let selected = this.getSelected();
            if(selected.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            OrderService.updateRemark(1, selected, this.getData);
        },
        //更新快递单号，更新架位号
        updateCode(detail){
            let stock = {id:detail.stockId, status: detail.status};
            let stockDetail = {id:detail.id, shelfCode: detail.shelfCode};
            StockDetailService.updateCode(
                stock,
                stockDetail,
                this.user.username,
                0,
                this.getData               
            );
        },
        //点到
        updateMark(detail, markVal){
            StockDetailService.updateMark(
                detail.stockId,
                detail.id,
                markVal,
                this.getData
            );
        },
        //删除快递单号
        deleteInnerCode(detail){
            StockDetailService.deleteInnerCode(
                detail.id,
                this.getData
            );
        },
        //编辑采购单号
        updatePurchaseCode(detail){
            this.purchaseCode = null;
            this.purchasePlatform = null;
            this.purchaseAmount = 0;
            this.purchaseCodevisible = true;
            this.selectedDetail = detail;
        },
        showSearchPurchaseCodeDialog(){
            this.$refs.SearchPurchaseCodeDialogRef.showDialog(0);
        },
        finishSearchPurchaseCode(order, rowIndex){
            this.purchaseCode = order.orderCode;
            this.purchasePlatform = 'pdd';
            this.purchaseAmount = order.price;
        },
        savePurchaseCode(){
            if(!this.purchaseCode){
                this.$message(this.msg('请输入采购单号'));
                return;
            }
            if(!this.purchasePlatform){
                this.$message(this.msg('请选择采购平台'));
                return;
            }
            this.selectedDetail.purchaseCode = this.purchaseCode;
            this.selectedDetail.purchasePlatform = this.purchasePlatform;
            this.selectedDetail.cost = this.purchaseAmount*100*this.selectedDetail.productQty;
            this.purchaseCodevisible = false;
            this.selectedDetail.cost = (this.selectedDetail.cost / 100).toFixed(2);
            StockDetailService.savePurchaseCode(
                this.selectedDetail.stockId,
                this.selectedDetail,
                this.getData
            );
        },
        //撤销已采购单号
        rebackPurchaseCode(detail){
            StockDetailService.rebackPurchaseCode(
                detail.stockId,
                detail.id,
                this.getData
            );
        },
        //更新SKU, 更新货号
        updateVariationSku(detail, type){

            let sku = {
                stockId:  detail.stockId,
                detailId:detail.id,
                sku: detail.sku,
                variationSku: detail.variationSku, 
            }

            this.$refs.SkuUpdateDialogRef.showDialog(sku, detail.stockId, detail.id, 0);
        },
        //编辑规格
        editProductSpec(detail){
            this.editingSpecId = detail.id;
            this.editingSpecValue = detail.productSpec || '';
            this.originalSpecValue = detail.productSpec || '';
            this.$nextTick(() => {
                const input = this.$refs['specInput_' + detail.id];
                if (input) {
                    if (Array.isArray(input)) {
                        input[0].focus();
                    } else {
                        input.focus();
                    }
                }
            });
        },
        //保存规格
        saveProductSpec(detail){
            if(this.editingSpecId !== detail.id) return;
            
            const newValue = this.editingSpecValue.trim();
            if(newValue === this.originalSpecValue){
                this.cancelEditProductSpec();
                return;
            }
            
            // 使用 updateProductSpec 接口更新规格
            this.$axios.post(this.$kit.api.stockDetail.updateProductSpec
                +"?detailId="+detail.id
                +"&stockId="+detail.stockId
                +"&productSpec="+encodeURIComponent(newValue)
            )
                .then((res) => {
                    if(res.status){
                        detail.productSpec = newValue;
                        this.$message(this.msg('更新成功'));
                        this.cancelEditProductSpec();
                    } else {
                        this.$message.error(this.msg('更新失败') + (res.msg ? ': ' + res.msg : ''));
                        this.cancelEditProductSpec();
                    }
                })
                .catch((err) => {
                    console.error('更新规格失败:', err);
                    this.$message.error(this.msg('更新失败'));
                    this.cancelEditProductSpec();
                });
        },
        //取消编辑规格
        cancelEditProductSpec(){
            this.editingSpecId = null;
            this.editingSpecValue = '';
            this.originalSpecValue = '';
        },
        //恢复同步快递按钮
        refreshSyncButton(){
            this.isSyncExpressDisabled = false;
            if(this.$refs.orderQueryRef && this.$refs.orderQueryRef.refreshSyncButton){
                this.$refs.orderQueryRef.refreshSyncButton();
            }
        },
        //更新成本
        doUpdateCost(detail){
            this.$refs.CostUpdateDialogRef.showDialog(detail.id);
        },
        doImport(){
            this.importVisible = true;
        },
        doCloseImport(done){
            this.getData(true);
            done();
        },
        doPrint(cmd,detail){
            this.$confirm(this.msg('是否要执行打印？'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // let selectes = [detail];
                if(cmd == 1){
                    this.printCtrls = [1]
                    this.$refs.printDg.preparePrint([detail.stockId], this.printCtrls);
                }else if(cmd == 2){
                    this.printCtrls = [0];
                    this.$refs.printDg.preparePrint([detail.stockId], this.printCtrls);
                }else if(cmd == 3){
                    this.printCtrls = [1];
                    this.$refs.printDg6.preparePrint([detail.stockId], this.printCtrls);
                }else if(cmd == 4){
                    this.printCtrls = [1];
                    this.$refs.printDg4.preparePrint([detail.stockId], this.printCtrls);
                }else if(cmd == 5){//货单&出货码
                    this.printCtrls = [1];
                    this.$refs.printDg3.showDialog([detail.stockId], this.printCtrls);
                }
            }).catch((err) => {
                // console.log(err);
            })
        },
        batchPrint(cmd){
            let selected = this.getSelected();
            if(selected.length == 0){
                this.$message.error(this.msg('请选择要打印的订单'));
                return;
            }
            this.$confirm(this.msg('是否要执行打印？'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // let selectes = [detail];
                const stockIds = [...new Set(selected.map(s => s.stockId))];
                if(cmd == 1){
                    this.printCtrls = [1]
                    this.$refs.printDg.preparePrint(stockIds, this.printCtrls);
                }else if(cmd == 2){
                    this.printCtrls = [0];
                    this.$refs.printDg.preparePrint(stockIds, this.printCtrls);
                }else if(cmd == 3){
                    this.printCtrls = [1];
                    this.$refs.printDg6.preparePrint(stockIds, this.printCtrls);
                }else if(cmd == 4){
                    this.printCtrls = [1];
                    this.$refs.printDg4.preparePrint(stockIds, this.printCtrls);
                }else if(cmd == 5){//货单&出货码
                    this.printCtrls = [1];
                    this.$refs.printDg3.showDialog(stockIds, this.printCtrls);
                }
            }).catch((err) => {
                // console.log(err);
            })
        },
        getStatus(stock){
            let status = this.getDicts('stockStatusInOrder').find(d => d.value === stock.status);
            return status? status.label: stock.status;
        },
        getStatusType(stock){
            let status = this.getDicts('stockStatusInOrder').find(d => d.value === stock.status);
            return status? status.type: 'primary';
        },
        getExpGoodType(stock){
            let status = this.getDicts('stockExpGoodType').find(d => d.value === stock.expGoodType);
            return status? status.label: '普货';
        },
        getExpPkgType(stock){
            let status = this.getDicts('stockExpPkgType').find(e => e.value === stock.expPkgType)
            return status? status.label: '';
        },
        //总成本计算，总成本=商品成本+运费成本+打包费+进店费+其它费用；商品成本=各详情成本累加；运费成本=个人设置的运费成本*托运重量
        getSumCost(order,detail){
            let productSum = 0;
            order.details.forEach(e => {
                productSum += e.cost;
            });
            let productCost = (productSum / 100).toFixed(2);
            let expPriCost = (Number(this.costSetting.expCost) || 0) * ((Number(detail.weightConsign) || 0) / 1000).toFixed(3);
            let sumCost = Number(productCost)
                + Number(expPriCost)
                + Number(this.costSetting.dabaoCost)
                + Number(this.costSetting.jindianCost)
                + Number(this.costSetting.otherCost);
            return sumCost > 0 ? Number(sumCost).toFixed(2) : 0;
        },
        // 预估利润=（预估进账/汇率）-商品成本-运费成本-打包费-进店费-其它费用；
        getSumProfit(order,detail){
            let escrowAmount = (Number(detail.escrowAmount) || 0) / (Number(this.costSetting.rate) || 4.5);
            let sumCost = this.getSumCost(order,detail);
            let profit = Number(escrowAmount) - Number(sumCost);
            return Number(profit).toFixed(2);
        },
        checkCost(order,detail){
            this.$refs.CostViewDialogRef.showDialog(order, detail, this.costSetting);
        },
        getPurchasePlatform(detail){
            let platform = detail.purchasePlatform;
            if(platform == 'taobao'){
                return '淘宝';
            }else if(platform == 'pdd'){
                return '拼多多';
            }else if(platform == 'alibaba' || platform == '1688'){
                return '1688';
            }
        },
        callSelectedMethod(callMethod){
            // var selectes = this.$refs.dataTable.getCheckboxRecords();
            // if(selectes.length==0){
            //     this.$message(this.msg('请选中一条数据进行操作'));
            //     return;
            // }else{
            //     callMethod(selectes);
            // }
        },
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            // this.selectedRows = [];
            this.getData();
        },
        doCtrlClick(command){
            console.log("in order1", command);
        },
        
        handleButtonMouseDown(event) {
            const button = event.currentTarget;
            button.classList.add('animating');
            
            // 动画播放完毕后移除class
            setTimeout(() => {
                button.classList.remove('animating');
            }, 300);
        },
        //同步店铺订单
        syncShop(){
            this.$refs.SyncOrderRef.showDialog();
        },
        doTrackExpress(){//快递同步
            this.isSyncExpressDisabled = true;
            this.$refs.SyncExpressDialogRef.showDialog();
        },
        doSyncExpress(){//执行同步
            
            console.log("执行同步快递");
            let selected = this.getSelected();
            trackExpress(
                selected.map(s => s.stockId),
                (result)=> {
                    if(result.status){
                        this.getData();
                        this.refreshSyncButton();
                    }
                },
                ()=>{
                    this.refreshSyncButton();
                }
            )
        },
        //导出订单详情
        exportDetail(){
            let ids;
            const idSet = new Set();
            this.orders.forEach(order => {
                order.details.forEach(detail => {
                    if(detail.selected){
                        idSet.add(detail.stockId);
                    }
                });
            });
            ids = Array.from(idSet).join(',');
            if(!ids){
                this.$message(this.msg('请选择一条数据进行导出'));
                return;
            }
            openWindowWithPost(
                    this.$kit.api.export.exportDetail,
                    {
                        ids:ids,
                        history:0
                    }
                );
        },
        //匹配库存
        matchStock(){//这里是调用货物转寄
            var _this = this;
            const idSet = new Set();
            this.orders.forEach(order => {
                order.details.forEach(detail => {
                    if(detail.selected){
                        idSet.add(detail.stockId);
                    }
                });
            });
            let selectIds = Array.from(idSet);
            if(selectIds.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            _this.$router.push({ name: 'stockMatch', params: {ids: selectIds}});
        },
        //查看面单
        expPageView(pageId){
            if(pageId){
                this.pageId = pageId;
                this.imgVisiable = true;
            }else{
                this.$message(this.msg('面单不存在'));
            }
        },
        //一键发货
        batchSendOrder(stockId){
            batchSendOrderNew(stockId);
        },
        //备货打包
        buildPkg(order){
            this.$refs.OrderPkgDialogRef.showDialog(order);
        },
        //更新订单
        refresh(){
            this.getData();
        },
        updateQty(detail){
            if(detail.shelfCode){
                this.$message("请先删除转寄单号回撤库存再更新数量");
                return;
            }

            StockDetailService.updateQty(
                detail.stockId,
                detail.id,
                this.getData
            );
        },
        doCancelStock(stockId){
            let item = 2;
            var _this = this;
            this.$axios.post(_this.$kit.api.stock.getStockByIds,stockId)
                .then((result) => {
                    let data = result.data;
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.expPageStatus >= 15 && e.status != 80 && e.status != 79){
                            this.$message(e.code+this.msg('面单已打印,不能取消订单'));
                            return;
                        }
                        if(e.isCancel == 2 && item == 2){
                            _this.$message(e.code+this.msg('已取消，不能进行操作'));
                            return;
                        }
                        if(e.isCancel == 0 && item == 0){
                            _this.$message(e.code+this.msg('未取消订单不能恢复'));
                            return;
                        }
                    }

                    let msg = '';
                    if(item == 2){
                        msg = this.msg('确定要取消所选订单吗?');
                    }else{
                        msg = this.msg('确定要恢复所选订单吗?');
                    }
                    this.$confirm(msg, this.msg('提示'), {
                        confirmButtonText: this.msg('确定'),
                        cancelButtonText: this.msg('取消'),
                        type: 'warning'
                    }).then(() => {
                        this.$axios.post(_this.$kit.api.updateColumn.updateCancel+'?value='+item+'&type=1',stockId)
                        .then((result) => {
                            if(result.status){
                                _this.$message(result.msg || _this.msg('更新成功'));
                                _this.getData;
                            }else{
                                _this.$message(result.msg || _this.msg('更新失败'));
                            }
                        });
                    }).catch((err) => {
                        _this.$message(_this.msg('取消操作'));
                    });
                })
        },
        switchTab(tab) {
            this.activeTab = tab;
            if(tab == 'pending'){
                this.query.status = 5;
            }else if(tab == 'shipping'){
                this.query.status = 10;
            }else if(tab == 'all'){
                this.query.status = '';
            }
            // 切换tab时重置选中状态
            this.selectAll = false;
            this.isIndeterminate = false;
            this.selectedStocks = [];
            this.orders.forEach(order => {
                order.selected = false;
            });
            this.getData();
        },
        handleSelectAll(value) {
            this.orders.forEach(order => {
                order.details.forEach(d => {
                    d.selected = value;
                });
            });

            this.updateSelectAllStatus();

        },
        handleSelect(value,detail){
            detail.selected = value;
        },
        updateSelectAllStatus() {

            let isSomeUnselected = this.orders.some(order => order.details.some(d => !d.selected));
            let isSomeSelected = this.orders.some(order => order.details.some(d => d.selected));
            this.selectAll = !isSomeUnselected;
            this.isIndeterminate = isSomeSelected && isSomeUnselected;
        },
        handleOrderSelect(order) {
            order.selected = !order.selected;
            this.updateSelectAllStatus();
        },
        //获取选中的订单
        getSelected(){
            let selectes = [];
            this.orders.forEach(order => {
                order.details.forEach(detail => {
                    if(detail.selected){
                        selectes.push(detail);
                    }
                });
            });
            return selectes;
        }, 
    },
    watch: {
        // 监听orders变化
        orders: {
            handler() {
                this.updateSelectAllStatus();
            },
            deep: true
        },
    },
}


</script>
 
<style scoped> 
.page-box{
    position: relative;
    height: calc(100vh - 84px);
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
}

.order-table-wrap{
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 100%; 
    box-sizing: border-box;
    flex: 1;
    padding-bottom: 15px;
}

.data-row{
    padding: 1px;
}

.table-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.data-row table, .table-header table{
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border-top: 1px solid #dcdfe6;
    border-left: 1px solid #dcdfe6;
    position: relative;
}

.data-row table:hover{
    box-shadow: 0 0 0 1px #0052d9;
}


.data-row td, .table-header td{ 
    padding: 8px;
    vertical-align: top;
    word-wrap: break-word;
    overflow-wrap: break-word;
    border-right: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    transition: border-color 0.2s ease;
    overflow: hidden;
    max-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.item1 {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
    overflow: hidden;
}

.product-info{
    flex: 1;
    min-width: 0;
    overflow: hidden;
    max-width: 100%;
}

.cell-1{
    font-size: 12px;
    color: #666;
    display: flex;
    margin-bottom: 4px;
    word-wrap: break-word;
}

.cell-1 > span:first-child{
    flex-shrink: 0;
    margin-right: 4px;
}

.cell-1 > span:last-child{
    color: #333; 
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
  
.product-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 7px;
    gap: 8px;
}

.product-title {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 13px; 
    color: #000;
    min-width: 0;
    cursor: pointer
}
.product-title-wrap{
    flex: 1;
    min-width: 0;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
}
.product-spec-wrap{
    flex: 1;
    min-width: 0;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
}
.sku-wrap{
    flex: 1;
    min-width: 0;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
}
.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em; /* 可以设为任意值，根据实际需要调整 */
    max-height: 7em; /* 根据行高计算出的最大高度，用于多行显示 */
}

.product-qty {
    font-size: 18px;
    color: #be0909 !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
    min-width: 35px !important;
    max-width: 35px !important;
    width: 35px !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    padding: 2px 4px;
    box-sizing: border-box;
    cursor: pointer
}

.product-qty span{
    font-size: 13px;
    color: #888;
    margin-right: 2px;
}

.ctrl-cell{
    font-size: 14px; 
}

.ctrl-cell > div{
    display: flex;
    cursor: pointer;
    align-items: center;
    opacity: 1;
    margin-bottom: 6px;
    word-wrap: break-word;
}

.ctrl-cell > div:hover{
    opacity: 0.8;
}

.ctrl-cell > div > i{
    margin-right: 8px;
    flex-shrink: 0;
}

.ctrl-cell > div > span{
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cell-2{
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    margin-bottom: 2px;
}

.cell-3{
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
}

.cell-4{
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.ctrl-button {
    background: white;
    border: 1px solid #d1d1d1;
    color: #000;
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}

.ctrl-button:hover {
    color: #0052d9;
    border-color: #0052d9;
}

.ctrl-button:active::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: #eee;
    z-index: 1;
    animation: fillLeft 0.3s ease forwards;
}

.ctrl-button.animating::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: #eee;
    z-index: 1;
    animation: fillLeft 0.3s ease forwards;
}

.ctrl-button span {
    position: relative;
    z-index: 2;
}

@keyframes fillLeft {
    to {
        left: 0;
    }
}

.pagenator {
    background: white;
    border-top: 1px solid #dcdfe6;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    z-index: 10;
    box-sizing: border-box;
    overflow: hidden;
}

.order-tabs {
    display: flex;
    gap: 15px;
    padding: 10px 0px 0px 15px;
}

.tab-item {
    cursor: pointer;
    padding: 8px ;
    border-bottom: 3px solid #fff;
    transition: all 0.3s ease;
    position: relative;
}

.tab-item.active {
    border-color: #0052d9;
    color: #0052d9;
}

.data-row table /deep/ .el-checkbox__inner{
    box-shadow: 0 0 0px 1px #409eff;
}

.purchase-status-ok{
    font-size:12px; 
    color: #5daf34;
    border-radius: 2px;
    border: 1px solid #5daf34;
    padding: 2px 4px;
    display: inline-block;
    text-align:center;
}
.purchase-status-error{
    font-size:12px; 
    color: #f56c6c;
    border-radius: 2px;
    border: 1px solid #f56c6c;
    padding: 2px 4px;
    display: inline-block;
    text-align:center;
}

.canedit {
    border: 1px solid #409EFF !important;
    border-radius: 4px;
    padding: 2px 4px;
    font-size: 12px;
    outline: none;
    background-color: #fff;
    width: 100%;
    box-sizing: border-box;
}

.canedit:focus {
    border-color: #409EFF;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.custom-radio {
  display: inline-block;
  cursor: pointer;
  user-select: none;
}

.custom-radio input[type="radio"] {
  display: none;
}

.custom-radio-btn {
  display: inline-block;
  padding: 1px 12px;
  height: 28px;
  line-height: 26px;
  background: rgba(0,0,0,0.09);
  border-radius: 2px;
  color: #333;
  border: 1px solid transparent;
  transition: all 0.2s;
  font-size: 14px;
}
.sort-icons {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-left: 6px;
  vertical-align: middle;
}
.sort-triangle {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.sort-triangle.up {
  border-bottom: 6px solid #c0c4cc;
}

.sort-triangle.down {
  border-top: 6px solid #c0c4cc;
}
.sort-icons.asc .sort-triangle.up {
  border-bottom-color: #0052d9;
}

.sort-icons.desc .sort-triangle.down {
  border-top-color: #0052d9;
}
</style>
